const config = {
      API_URL: "https://api.skynyx.dev",
      // API_URL: "http://localhost:8000",

      // Public marketing/tools/docs site (PHP). The auth pages' marketing
      // navbar/footer link out to this, since those pages now live only there.
      SITE_URL: "https://skynyx.dev",
};

export default config;